import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";
import PDFToPPTUploadView from "./PDFToPPTUploadView";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";

function PDFToPPTMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PDF To PPT Converter Online Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_to_ppt", title: "Convert PDF To PPT Online" },
    data2: { link: "/pdf_to_ppt", title: "PDF To Powerpoint Presentation" },
    data3: { link: "/pdf_to_ppt", title: "PDF To Slides Online" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PDF to PPT online instantly. Turn PDFs into editable PowerPoint slides quickly with our fast and secure PDF to PPT converter."
      ></meta>
      <meta
        name="keywords"
        content="pdf to ppt, pdf to powerpoint, convert pdf to ppt, pdf to ppt online, pdf to powerpoint online, pdf presentation converter, pdf slides converter, pdf to pptx, pdf to powerpoint converter, online pdf to ppt, editable powerpoint from pdf, pdf presentation tool, pdf conversion tool, pdf to slides, pdf editor online, pdf to pptx online, pdf to ppt converter online, online pdf to ppt converter free, free pdf converter, pptx converter,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload PDF View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {showEditFileScreen ? (
          <PDFToPPTUploadView
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            allowedFileExtensions={["pdf"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our PDF to PPT online website is a powerful and user-friendly solution designed to convert PDF documents into fully editable PowerPoint presentations with accuracy and speed. This advanced PDF to PowerPoint converter online extracts text, images, charts, and layouts from PDF files and transforms them into PPT or PPTX slides while maintaining the original formatting as closely as possible. Whether you are a student preparing class presentations, a professional updating business reports, or a teacher reusing lecture materials, this convert PDF to PPT online tool simplifies your workflow and saves valuable time. With a clean and intuitive interface, users can upload PDF files and convert them to PowerPoint in just a few clicks—no technical skills or software installation required. Our PDF to PPT converter online works directly in your browser and supports high-quality output suitable for editing, presenting, and sharing. Strong security measures ensure your documents remain safe, with files processed securely and removed automatically after conversion. By turning static PDFs into editable PowerPoint slides, this tool enables easy content reuse, collaboration, and customization. If you’re searching for a fast, reliable, and accurate PDF to PowerPoint online converter that delivers professional results without compromising quality, this website is the ideal choice for modern document conversion needs." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="PDF To PPT Converter"
          why_use={[
            {
              title: "Convert PDFs into Editable Presentations",
              description:
                "Our PDF to PPT online converter allows you to transform static PDF files into fully editable PowerPoint presentations, making it easy to update content, change layouts, and reuse information efficiently.",
            },

            {
              title: "Save Time and Manual Effort",
              description:
                "Using a convert PDF to PPT online tool eliminates the need to manually recreate slides, helping users quickly convert PDF documents into PowerPoint format with minimal effort.",
            },

            {
              title: "Preserve Original Layout and Design",
              description:
                "This reliable PDF to PowerPoint converter online maintains fonts, images, tables, and slide structure, ensuring your converted PPT files retain a professional and consistent appearance.",
            },

            {
              title: "Boost Productivity and Workflow",
              description:
                "With a fast PDF to PPT online website, students, teachers, and professionals can convert files quickly, improving productivity and streamlining presentation creation.",
            },

            {
              title: "No Software Installation Required",
              description:
                "This browser based PDF to PPT converter online works without downloading or installing software, allowing users to convert PDF to PowerPoint instantly from any device.",
            },

            {
              title: "Ideal for Business and Academic Use",
              description:
                "Our PDF to PPT online tool is perfect for business reports, training materials, academic presentations, and lecture slides that require editing and customization.",
            },

            {
              title: "Easy Content Reuse and Collaboration",
              description:
                "Converting PDF to PPT online enables easy collaboration by allowing teams to share editable PowerPoint files instead of static PDFs.",
            },

            {
              title: "High Quality Presentation Output",
              description:
                "Our powerful PDF to PowerPoint online converter delivers high quality PPT slides suitable for meetings, conferences, and classroom presentations.",
            },

            {
              title: "Supports Complex and Text Based PDFs",
              description:
                "Our advanced PDF to PPT online converter can handle text-heavy documents and complex layouts, ensuring accurate and reliable PowerPoint conversions.",
            },
          ]}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default PDFToPPTMain;
